module.exports = __webpack_public_path__ + "static/img/tabletupianb2.6a38a4d.png";